import { useQuery } from "@tanstack/react-query";
import { sharedApi } from "@/lib/api";

/**
 * Global site settings from Admin → Site Settings.
 * All fields nullable — render icons/rows only when present.
 * See docs: GET /api/classifieds/site-settings?country=NZ
 */
export function useSiteSettings() {
  return useQuery({
    queryKey: ["site-settings", "NZ"],
    queryFn: async () => {
      const { data } = await sharedApi.get("/classifieds/site-settings", {
        params: { country: "NZ" },
      });
      return data?.settings || {};
    },
    staleTime: 30 * 60_000,
    retry: 0,
  });
}
